var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentConnect({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 112,
    viewBox: "0 0 50 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79422 0C4.27879 1.57087 4 3.24902 4 4.99227V91.9923C4 100.829 11.1634 107.992 20 107.992H45C46.7433 107.992 48.4214 107.713 49.9923 107.198C46.4973 110.187 41.9594 111.992 37 111.992H20C8.9543 111.992 0 103.038 0 91.9923V12.9923C0 8.03284 1.80514 3.49502 4.79422 0Z",
    fill: "#F6F6F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentConnect);
export default __webpack_public_path__ + "static/media/comment_connect.964d525312f5074c59733b964130df03.svg";
export { ForwardRef as ReactComponent };